 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"froala-css":"froala-css"}[chunkId]||chunkId) + "." + {"chunk-05ee1fd6":"106b583f","chunk-0ee2a8fc":"bee7ddaf","chunk-113a98eb":"7b262bd3","chunk-13d2d938":"39fdecc5","chunk-1c27f64a":"3178f768","chunk-1cea07be":"a9a2ac3f","chunk-20e8b8c8":"6cadd261","chunk-28eb48ea":"0fcfa907","chunk-2ba43040":"34a3cf2b","chunk-2c73e111":"668fa494","chunk-2cbf3ed4":"cc84b476","chunk-2d0a440a":"ef2b4a26","chunk-2d0d05d7":"e6dbb508","chunk-2d0d6358":"925c27e0","chunk-2d0d7db6":"dc5d3bcc","chunk-2d0de124":"80cbf7a7","chunk-2d0e28f0":"aa2a70bf","chunk-2d207cfd":"860d04de","chunk-2d207f94":"f9f9c9db","chunk-2d20eff2":"2b1a9f6e","chunk-2d216c13":"037b2af6","chunk-2d2170f6":"9d06cb5b","chunk-2d217a0c":"c02d4324","chunk-2da69bb5":"dfb383f2","chunk-2d0c8472":"b8cdd96a","chunk-47d656ac":"05d5d50d","chunk-0795e994":"eae44037","chunk-2d0c037d":"068c895b","chunk-b096747e":"b39fef6e","chunk-093917b0":"037cf10f","chunk-3d0cdbd3":"8f879126","chunk-7e729453":"821942b9","chunk-cf99725e":"f07077df","chunk-3819332c":"414be285","chunk-3c08f264":"f45e2c37","chunk-3c234890":"0c226a2c","chunk-461a8535":"0b521bda","chunk-4658e21d":"561fbcec","chunk-2d0e4810":"7f1e2a06","chunk-2d0e4c5d":"1fa0f541","chunk-484f2f4a":"c2dd0da2","chunk-50aa4cea":"4ef5f3e6","chunk-56e6a68c":"af398fc7","chunk-6455b7ea":"51c3bb09","chunk-650ed63e":"fc822ead","chunk-6843d77e":"ed574d40","chunk-69bb90bd":"9b017bfe","chunk-6dad4bc8":"942b06bd","chunk-6e63b018":"85fc97bb","chunk-707565f0":"f6d9e629","chunk-4eedc7aa":"d31d7862","chunk-778e4c76":"2bc0af49","chunk-74c6ba91":"dfbedd99","chunk-77983290":"05cb9b65","chunk-07d43dea":"f52a4654","chunk-3244c2c4":"7b27c55b","chunk-78441b16":"ca765944","chunk-797b3102":"4815dbc5","chunk-98f9a186":"780e7339","chunk-9acbb70c":"ab2f5223","chunk-9add4f44":"80adadac","chunk-a502b19e":"511f4116","chunk-aa2d91c8":"a60c22ff","chunk-ca65fed8":"cf4b3276","chunk-f6d88858":"82cb941c","chunk-f9425a34":"92a8d429","chunk-e8eddc68":"27d632c7","chunk-ec926c00":"ed8e4967","froala-css":"0e30f01d","chunk-65f21494":"72c5e9c8","chunk-21e7c4c5":"65ca4891","chunk-2333febe":"6d4ba274","chunk-409b1c13":"1a8cb1d9","chunk-6d1c0bbb":"95ccf882","chunk-2d0a36c5":"35186b70","chunk-2d0a4249":"b1965222","chunk-f2061188":"1aaad184"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05ee1fd6":1,"chunk-0ee2a8fc":1,"chunk-113a98eb":1,"chunk-13d2d938":1,"chunk-1c27f64a":1,"chunk-1cea07be":1,"chunk-20e8b8c8":1,"chunk-28eb48ea":1,"chunk-2ba43040":1,"chunk-2c73e111":1,"chunk-2cbf3ed4":1,"chunk-47d656ac":1,"chunk-0795e994":1,"chunk-b096747e":1,"chunk-093917b0":1,"chunk-3d0cdbd3":1,"chunk-7e729453":1,"chunk-cf99725e":1,"chunk-3819332c":1,"chunk-3c08f264":1,"chunk-3c234890":1,"chunk-461a8535":1,"chunk-4658e21d":1,"chunk-484f2f4a":1,"chunk-50aa4cea":1,"chunk-56e6a68c":1,"chunk-6455b7ea":1,"chunk-650ed63e":1,"chunk-6843d77e":1,"chunk-69bb90bd":1,"chunk-6dad4bc8":1,"chunk-6e63b018":1,"chunk-707565f0":1,"chunk-4eedc7aa":1,"chunk-778e4c76":1,"chunk-74c6ba91":1,"chunk-77983290":1,"chunk-07d43dea":1,"chunk-3244c2c4":1,"chunk-78441b16":1,"chunk-797b3102":1,"chunk-98f9a186":1,"chunk-9acbb70c":1,"chunk-9add4f44":1,"chunk-a502b19e":1,"chunk-aa2d91c8":1,"chunk-f6d88858":1,"chunk-f9425a34":1,"chunk-ec926c00":1,"froala-css":1,"chunk-65f21494":1,"chunk-21e7c4c5":1,"chunk-2333febe":1,"chunk-409b1c13":1,"chunk-6d1c0bbb":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"froala-css":"froala-css"}[chunkId]||chunkId) + "." + {"chunk-05ee1fd6":"031925bb","chunk-0ee2a8fc":"0eaabe7d","chunk-113a98eb":"0abb22fd","chunk-13d2d938":"3092fbdf","chunk-1c27f64a":"84ac8298","chunk-1cea07be":"fc6708b3","chunk-20e8b8c8":"1e8dc569","chunk-28eb48ea":"1d1e3d79","chunk-2ba43040":"639b313d","chunk-2c73e111":"2c87cd05","chunk-2cbf3ed4":"b4d2b139","chunk-2d0a440a":"e3b0c442","chunk-2d0d05d7":"e3b0c442","chunk-2d0d6358":"e3b0c442","chunk-2d0d7db6":"e3b0c442","chunk-2d0de124":"e3b0c442","chunk-2d0e28f0":"e3b0c442","chunk-2d207cfd":"e3b0c442","chunk-2d207f94":"e3b0c442","chunk-2d20eff2":"e3b0c442","chunk-2d216c13":"e3b0c442","chunk-2d2170f6":"e3b0c442","chunk-2d217a0c":"e3b0c442","chunk-2da69bb5":"e3b0c442","chunk-2d0c8472":"e3b0c442","chunk-47d656ac":"c17afa82","chunk-0795e994":"253b32e1","chunk-2d0c037d":"e3b0c442","chunk-b096747e":"94b15217","chunk-093917b0":"319e4b66","chunk-3d0cdbd3":"319e4b66","chunk-7e729453":"0ca26df3","chunk-cf99725e":"578486cc","chunk-3819332c":"94c6da29","chunk-3c08f264":"ca823c8e","chunk-3c234890":"8f3e51ff","chunk-461a8535":"eeab3df4","chunk-4658e21d":"c030a546","chunk-2d0e4810":"e3b0c442","chunk-2d0e4c5d":"e3b0c442","chunk-484f2f4a":"a456fdf1","chunk-50aa4cea":"2f2285fb","chunk-56e6a68c":"2218f529","chunk-6455b7ea":"6f449fb4","chunk-650ed63e":"9d48c5dd","chunk-6843d77e":"fbcca0d6","chunk-69bb90bd":"53bd7148","chunk-6dad4bc8":"24abbbb7","chunk-6e63b018":"ca823c8e","chunk-707565f0":"1af8d843","chunk-4eedc7aa":"40949e7a","chunk-778e4c76":"0876d0c6","chunk-74c6ba91":"5ba5d7c3","chunk-77983290":"021856e3","chunk-07d43dea":"0be31bcd","chunk-3244c2c4":"4bc5ef74","chunk-78441b16":"772a42cb","chunk-797b3102":"20cfcf07","chunk-98f9a186":"60532bf2","chunk-9acbb70c":"2f659dfa","chunk-9add4f44":"369d32e3","chunk-a502b19e":"3b33a16a","chunk-aa2d91c8":"c39e27b1","chunk-ca65fed8":"e3b0c442","chunk-f6d88858":"28a829d6","chunk-f9425a34":"059764f2","chunk-e8eddc68":"e3b0c442","chunk-ec926c00":"544a76d8","froala-css":"0220d57e","chunk-65f21494":"5b435c02","chunk-21e7c4c5":"3fcaf999","chunk-2333febe":"13d130db","chunk-409b1c13":"034235c3","chunk-6d1c0bbb":"b7504dc8","chunk-2d0a36c5":"e3b0c442","chunk-2d0a4249":"e3b0c442","chunk-f2061188":"e3b0c442"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
